// Copyright 2026. WebPros International GmbH. All rights reserved.

import { connect } from 'react-redux';
import {
    bindActionCreators,
    Dispatch,
} from 'redux';
import * as computeResourceVmActions from 'common/modules/computeResourceVm/actions';
import { RootState } from 'admin/core/store';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import { unsetList } from 'common/modules/backup/actions';
import { BackupsTab } from 'common/components/ServerTabs/BackupsTab/BackupsTab';
import { BackupsTableColumns } from 'common/modules/backup/containers/BackupsTable';
import { hasPermission } from 'common/modules/permission/selectors';
import { PERMISSION_LIST } from 'common/modules/permission/constants';

const mapStateToProps = (state: RootState) => ({
    columns: {
        [BackupsTableColumns.ID]: { width: '1%' },
        [BackupsTableColumns.STATUS]: { width: '10%' },
        [BackupsTableColumns.CREATED_AT]: { width: '10%' },
        [BackupsTableColumns.CREATION_METHOD]: { width: '10%' },
        [BackupsTableColumns.SIZE]: { width: '10%' },
        [BackupsTableColumns.DISK]: { width: '10%' },
        [BackupsTableColumns.BACKUP_NODE]: { width: '10%' },
        [BackupsTableColumns.BACKUP_TYPE]: { width: '10%' },
        [BackupsTableColumns.CREATOR]: { width: '10%' },
        [BackupsTableColumns.ACTIONS]: { width: '1%' },
    },
    confirmEnableBackupsOnQcow: true,
    item: state.computeResourceVm.item,
    isBackupSettingsUpdating: state.app.loadingFlags.has(LOADING_FLAGS.COMPUTE_RESOURCE_VM_BACKUP_SETTINGS_UPDATE),
    isBackupLoading: state.app.loadingFlags.has(LOADING_FLAGS.BACKUP_LIST),
    shouldShowBackupsWhenDisabled: hasPermission(state, PERMISSION_LIST.MANAGE_BACKUPS),
    isBackupEnabledGlobally: state.settings.server_backup.is_enabled
        && state.settings.server_backup.compute_resources
            .map(cr => cr.id)
            .includes(state.computeResourceVm.item.compute_resource!.id),
    isDisasterRecoverySettingsUpdating: state.app.loadingFlags.has(LOADING_FLAGS.SERVER_DISASTER_RECOVERY_SETTINGS_UPDATE),
    canManageDisasterRecovery: hasPermission(state, PERMISSION_LIST.MANAGE_DISASTER_RECOVERY),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    computeResourceVmActions: bindActionCreators(computeResourceVmActions, dispatch),
    unsetBackups: bindActionCreators(unsetList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BackupsTab);
